import useSelectedPassengerClass from "@CheckOrder/features/classPicker/hooks/useSelectedPassengerClass";
import useAdditionalPassengerClassSelectModal
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/hooks/useAdditionalPassengerClassSelectModal";
import PassengerClassSelectModal
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/components/PassengerClassSelectModal";
import ClassPickerDropdown from "@CheckOrder/features/classPicker/components/ClassPickerDropdown";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

interface ReturnClassPickerProps {
    passengerId: number,
}

function ReturnClassPicker({passengerId}: ReturnClassPickerProps) {
    const {
        singleRoutePassengerClasses,
        returnRoutePassengerClasses,
    } = useAppSelector((state) => (state.checkOrder.ticket.passengerClasses))

    const {
        selectedPassengerClass: singleSelectedPassengerClass,
        setSelectedPassengerClass: setSingleSelectedPassengerClass,
    } = useSelectedPassengerClass(passengerId, singleRoutePassengerClasses)

    const {
        dialogRef: singleDialogRef,
        closeModal: singleCloseModal,
        newlySelectedPassengerClass: singleNewlySelectedPassengerClass,
        setNewlySelectedPassengerClass: setSingleNewlySelectedPassengerClass,
    } = useAdditionalPassengerClassSelectModal()

    const {
        selectedPassengerClass: returnSelectedPassengerClass,
        setSelectedPassengerClass: setReturnSelectedPassengerClass,
    } = useSelectedPassengerClass(passengerId, returnRoutePassengerClasses, true)

    const {
        dialogRef: returnDialogRef,
        closeModal: returnCloseModal,
        newlySelectedPassengerClass: returnNewlySelectedPassengerClass,
        setNewlySelectedPassengerClass: setReturnNewlySelectedPassengerClass,
    } = useAdditionalPassengerClassSelectModal()

    return (
        <>
            <PassengerClassSelectModal
                dialogRef={singleDialogRef}
                closeModal={singleCloseModal}
                passengerId={passengerId}
                selectedPassengerClass={singleNewlySelectedPassengerClass}
                setSelectedPassengerClass={setSingleSelectedPassengerClass}
            />
            <PassengerClassSelectModal
                dialogRef={returnDialogRef}
                closeModal={returnCloseModal}
                passengerId={passengerId}
                selectedPassengerClass={returnNewlySelectedPassengerClass}
                setSelectedPassengerClass={setReturnSelectedPassengerClass}
                isReturn
            />
            <div className="passenger-class__select-group">
                <ClassPickerDropdown
                    passengerId={passengerId}
                    availablePassengerClassesGroups={singleRoutePassengerClasses}
                    selectedPassengerClass={singleSelectedPassengerClass}
                    setSelectedPassengerClass={setSingleSelectedPassengerClass}
                    setNewlySelectedPassengerClass={setSingleNewlySelectedPassengerClass}
                />
                <ClassPickerDropdown
                    passengerId={passengerId}
                    availablePassengerClassesGroups={returnRoutePassengerClasses}
                    selectedPassengerClass={returnSelectedPassengerClass}
                    setSelectedPassengerClass={setReturnSelectedPassengerClass}
                    setNewlySelectedPassengerClass={setReturnNewlySelectedPassengerClass}
                    isReturn
                />
            </div>
        </>
    );
}

export default ReturnClassPicker